import { DATE_FORMAT } from "helpers/common";
import React from "react";

const Columns = ({}) => [
  {
    dataField: "coinName",
    text: "Coin",
    formatter: (_, row) => (
      <div className="d-flex align-items-center" style={{ gap: 5 }}>
        <img
          src={row?.coinIcon}
          alt=""
          className="img-fluid rounded-full object-fit-cover flex-shrink-0"
          style={{ height: 30, width: 30 }}
        />
        <span className="text-capitalize">{row?.coinName}</span>
      </div>
    ),
  },
  {
    dataField: "coinSymbol",
    text: "Coin Symbol",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.coinSymbol}</span>
    ),
  },
  {
    dataField: "totalAmount",
    text: "Total Amount",
    formatter: (_, row) => (
      <span className="text">
        {Number(row?.totalAmount || 0).toFixed(2)}
      </span>
    ),
  },
  {
    dataField: "leftAmount",
    text: "Left Amount",
    formatter: (_, row) => (
      <span className="text">
        {Number(row?.leftAmount || 0).toFixed(2)}
      </span>
    ),
  },
  {
    dataField: "type",
    text: "Type",
    formatter: (_, row) => (
      <span className="text">
        {row?.type
          ? row.type.charAt(0).toUpperCase() + row.type.slice(1)
          : ""}
      </span>
    ),
  },
  {
    dataField: "status",
    text: "Status",
    formatter: (_, row) => (
      <span className="text">
        {row?.status
          ? row.status.charAt(0).toUpperCase() + row.status.slice(1)
          : ""}
      </span>
    ),
  },
  {
    dataField: "date_created_utc",
    text: "Created At",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row.date_created_utc && DATE_FORMAT(row.date_created_utc)}
      </span>
    ),
  },
  {
    dataField: "date_modified_utc",
    text: "Updated At",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row.date_modified_utc && DATE_FORMAT(row.date_modified_utc)}
      </span>
    ),
  },
];
export default Columns;
